import { TestPanel } from '@/app'
import { Text } from '@/components'
import { variantProvider } from '@/app'
import { useState } from 'react'
import { impersonateStore } from '@/stores'

export function ImpersonatingBanner() {
  const isImpersonating = impersonateStore.useIsImpersonating()
  const testPanel = TestPanel.use()

  const [hidden, setHidden] = useState(false)

  if (!isImpersonating || !testPanel.enabled || hidden) return

  const onPress = () => {
    setHidden(true)
    setTimeout(() => {
      setHidden(false)
    }, 10000)
  }

  return <div onDoubleClick={onPress} style={styles.wrapper}>
    <Text text={`IMPERSONATING`} variants={['p3', 'color:neutral1']} />
  </div>
}

const styles = variantProvider.createComponentStyle(theme => {
  return {
    wrapper: {
      backgroundColor: theme.colors.alert2,
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      alignItems: 'center',
      ...theme.spacing.padding(1),
      paddingTop: 0,
      opacity: 0.6,
    },
  }
}, true)